import {Component, Input, OnInit} from '@angular/core';
import {RaceService} from "@services";
import {EventRaceItem, ItemType, Lookups, Message} from "@model";

@Component({
  selector: 'app-user-profile-dashboard',
  templateUrl: './user-profile-dashboard.component.html',
  styleUrls: ['./user-profile-dashboard.component.scss']
})
export class UserProfileDashboardComponent implements OnInit {
  @Input({required: true}) languages: Lookups[] = [];
  @Input() favoriteItems: EventRaceItem[] = [];
  @Input() countries: Lookups[] = [];
  @Input() unreadMessages: Message[] | undefined;

  constructor(private raceService: RaceService) {
  }

  ngOnInit(): void {
    this.raceService.findRecommendedRaces();
  }
}
